export default __webpack_public_path__ + "static/media/snail.9d0c7dad.png";